// import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Config from "../../Config";

function PaymentDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const tempBillDesc = "ViewQwest Digital Subscription Payment for: ";


//   const [email, setEmail] = useState(location.state.email);
//   const [amount, setAmount] = useState(location.state.amount);
//   const [invoiceNumber, setInvoiceNumber] = useState(location.state.orderId);
//   const [orderId, setOrderId] = useState(location.state.orderId);
//   const [mobile, setMobile] = useState(location.state.mobile);
//   const [name, setName] = useState(location.state.name);
//   const [accountNo, setAccountNo] = useState(location.state.account_no);
//   const [vcode, setVcode] = useState(location.state.vcode);
//   const [billDesc, setBillDesc] = useState(
//     tempBillDesc + location.state.orderId
//   );
//   const [id, setId] = useState(location.state.id);
let tempMobile = 0;



  const [email, setEmail] = useState();
  const [amount, setAmount] = useState();
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [orderId, setOrderId] = useState();
  const [mobile, setMobile] = useState();
  const [name, setName] = useState();
  const [accountNo, setAccountNo] = useState();
  const [vcode, setVcode] = useState();
  const [billDesc, setBillDesc] = useState(
   
  );
  const [id, setId] = useState();

  const handleSubmit = (event) => {
     localStorage.setItem("invoiceid", location.state.orderId);
  };
  const handleCancel = () => {
    navigate("/direct-pay/" + id);
	
  };

  useEffect(()=> {
	document.title = "Payment Details";
	if(!location.state){
		// alert();
		navigate("/direct-pay/guest");
	} else {
   

    setName(location.state.name);
		setAccountNo(location.state.account_no);
		setVcode(location.state.vcode);
		setBillDesc(tempBillDesc + location.state.orderId);
		setId(location.state.id);
    
		setEmail(location.state.email);
		setAmount(location.state.amount);
		setInvoiceNumber(location.state.orderId);
		setOrderId(location.state.orderId);
   
    
	

	}
  });

  useEffect(() => {
    let tempMobile = location.state.mobile;
    let localStorageMobile = localStorage.setItem('mobile', tempMobile);
    let savedLocalStorageMobile = localStorage.getItem('mobile');
    if (savedLocalStorageMobile){
      setMobile(savedLocalStorageMobile)
    }
		localStorage.clear();
  },[])

 

  const onChangeMobile = (e) => {
    const newValue = e.target.value;
    setMobile(newValue);

    localStorage.setItem('mobile', newValue)
  
  }

  return (
    <div className="h-screen flex items-center content-center justify-center align-middle">
      <div className="card sm:w-4/5  lg:w-2/5 bg-base-100 shadow-xl">
        <div className="card-body">
          <h1 className="text-left text-4xl">Payment Details</h1>
          <hr />

          <Form method="POST" action={Config.RAZER_URL} onSubmit={handleSubmit}>
            <div className="mb-6 mt-6">
              <label
                for="account_number"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Account Number
              </label>
              <input
                type="text"
                id="account_number"
                value={accountNo}
                
                
                // className="input input-bordered w-full max-w-xs"
                className="mb-6 bg-gray-100 border border-gray-300 text-gray-900 text-md rounded-lg  block w-full p-2.5 cursor-not-allowed white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-gray-400 white:focus:ring-blue-500 white:focus:border-blue-500 "
              />
            </div>

            <div className="mb-6 mt-6">
              <label
                for="bill_name"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Name
              </label>
              <input
              
                type="text"
                id="bill_name"
                name="bill_name"
                value={name}
                className="mb-6 bg-gray-100 border border-gray-300 text-gray-900 text-md rounded-lg  block w-full p-2.5 cursor-not-allowed white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-gray-400 white:focus:ring-blue-500 white:focus:border-blue-500 "
              />
            </div>

            <div className="mb-6 mt-6">
              <label
                for="bill_mobile"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Mobile
              </label>
              <input
                type="text"
                id="bill_mobile"
                name="bill_mobile"
                value={mobile}
                onChange={onChangeMobile}
                className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-white white:focus:ring-blue-500 white:focus:border-blue-500"
              />
            </div>

            <div className="mb-6 mt-6">
              <label
                for="bill_email"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Email
              </label>
              <input
                type="text"
                id="bill_email"
                name="bill_email"
                
                value={email}
                className="mb-6 bg-gray-100 border border-gray-300 text-gray-900 text-md rounded-lg  block w-full p-2.5 cursor-not-allowed white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-gray-400 white:focus:ring-blue-500 white:focus:border-blue-500 "
              />
            </div>

            <div className="mb-6 mt-6">
              <label
                for="invoiceNumber"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Invoice Number
              </label>
              <input
                type="text"
                id="invoiceNumber"
                
                value={invoiceNumber}
                className="mb-6 bg-gray-100 border border-gray-300 text-gray-900 text-md rounded-lg  block w-full p-2.5 cursor-not-allowed white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-gray-400 white:focus:ring-blue-500 white:focus:border-blue-500 "
              />
            </div>

            <div className="mb-6 mt-6">
              <label
                for="amount"
                className=" text-left block mb-2 text-sm font-medium text-gray-900 white:text-white"
              >
                Amount <span className="text-secondary">(MYR)</span>
              </label>
              <input
                type="text"
                id="amount"
                name="amount"
                
                value={amount}
                className="mb-6  bg-gray-100 border border-gray-300 text-gray-900 text-md rounded-lg  block w-full p-2.5 cursor-not-allowed white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-gray-400 white:focus:ring-blue-500 white:focus:border-blue-500 "
              />
            </div>

            <input
              type="hidden"
              id="orderid"
              name="orderid"
              value={orderId}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-white white:focus:ring-blue-500 white:focus:border-blue-500"
            />

            <input
              type="hidden"
              id="bill_desc"
              name="bill_desc"
              value={billDesc}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-white white:focus:ring-blue-500 white:focus:border-blue-500"
            />

            <input
              type="hidden"
              id="vcode"
              name="vcode"
              value={vcode}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-white white:focus:ring-blue-500 white:focus:border-blue-500"
            />
            <input
              type="hidden"
              id="country"
              name="country"
              value="MY"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 white:bg-gray-700 white:border-gray-600 white:placeholder-gray-400 white:text-white white:focus:ring-blue-500 white:focus:border-blue-500"
            />

            <div className="text-end ml-3 mt-3">
          
              <button
                className="text-white  bg-red-600  focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-xl text-sm px-7 py-2.5 text-center mr-2 mb-2  mt-3"
                onClick={handleSubmit}
                value="Submit"
                type="submit"
              >Submit</button>
              <Button
                variant="secondary"
                onClick={(e) => {
                  handleCancel(e);
                }}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default PaymentDetails;
